import { useLang } from "@/i18n/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitch({ variant = "default" }) {
  const { lang, setLang, langs } = useLang();
  const current = langs.find((l) => l.code === lang) || langs[0];

  const triggerClass =
    variant === "hero"
      ? "inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3.5 py-2 text-xs font-semibold text-white backdrop-blur transition hover:bg-white/20"
      : "inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-white/70 px-3.5 py-2 text-xs font-semibold text-zinc-700 backdrop-blur transition hover:border-[color:var(--sentinel)] hover:text-[color:var(--sentinel)]";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={triggerClass}
        data-testid="language-switch-trigger"
        aria-label="Language"
      >
        <Globe className="h-3.5 w-3.5" />
        <span className="uppercase">{current.code}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px] rounded-xl">
        {langs.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => setLang(l.code)}
            data-testid={`language-option-${l.code}`}
            className="flex items-center justify-between gap-3 rounded-lg text-sm"
          >
            <span>{l.label}</span>
            {l.code === lang && (
              <Check className="h-4 w-4 text-[color:var(--sentinel)]" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
